import styles from '../violationModal.module.scss';
type TItemProps = {
  value: string;
  name: string;
  title: string;
  formikRef: unknown;
};

export default function Item({value, title, name, formikRef}: TItemProps) {
  return (
    <div className={styles['violation-items-radio']}>
      <input
        type="radio"
        id={value}
        name={name}
        value={value}
        onChange={e =>
          //@ts-ignore
          formikRef.current.setFieldValue('reason', e.target.value)
        }
      />
      <label htmlFor={value}>{title}</label>
      <br />
    </div>
  );
}
